export default {
  title: "Non autorisé",
  description: `<p>Accès refusé. Vous n'avez pas la permission de voir cette page.</p>
            <p>Si vous pensez qu'il s'agit d'une erreur, veuillez contacter le support.</p>`,
};
